<script>
import AdminLayout from '@layouts/admin-main'
import { fetchConfig, updateConfig } from '@apis/admin/config'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'

export default {
  components: { AdminLayout },
  data() {
    return {
      config: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadConfig()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadConfig() {
      const { config } = await fetchConfig('otp')
      this.config = config
    },
    handleUpdate() {
      this.loading = true
      this.$confirm(this.$t('admin.msg_save'), this.$t('admin.modal_confirm'), {
        type: 'warning',
      })
        .then(() => updateConfig('otp', this.config))
        .then(() => this.loadConfig())
        .then(() =>
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('admin.msg_save_success'),
            type: 'success',
          })
        )
        .catch((e) => (e === 'cancel' ? null : this.$toasted.error(e.message)))
        .finally(() => {
          this.loading = false
        })
    },
    fromPairs,
  },
  page: {
    title: 'Admin::ConfigOtp',
    meta: [{ name: 'description', content: 'Admin::ConfigOtp' }],
  },
}
</script>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>

<template>
  <AdminLayout>
    <div>
      <form
        v-if="config"
        v-loading="loading"
        action="./"
        method="get"
        @submit.prevent="handleUpdate"
      >
        <h3 :class="$style.xeAdmin">{{ $t('admin.otp_setting') }}</h3>
        <div :class="$style.infoText">
          <p>{{ $t('admin.msg_otp_setting') }}</p>
        </div>
        <table :class="$style.rowTable" cellpadding="0">
          <colgroup>
            <col width="200" />
            <col width="35%" />
            <col width="200" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="col"
                ><div>{{ $t('admin.allow_disable_otp') }}</div></th
              >
              <td>
                <input
                  v-model="config.allow_disable_otp"
                  type="checkbox"
                  false-value="N"
                  true-value="Y"
                />
              </td>
              <th scope="col"
                ><div>{{ $t('admin.max_otp_count') }}</div></th
              >
              <td>
                <input
                  v-model="config.max_otp_count"
                  type="text"
                  :class="[$style.inputTypeText, $style.w80, $style.tRight]"
                />
              </td>
            </tr>
            <tr>
              <th scope="col"
                ><div>{{ $t('admin.otp_available_actions') }}</div></th
              >
              <td colspan="3">
                <label
                  v-for="[action, action_title] in constants.otp
                    .available_actions"
                  :key="action"
                >
                  <input
                    v-model="config.apply_actions"
                    type="checkbox"
                    :value="action"
                  />
                  {{ action_title }}
                </label>
              </td>
            </tr>
          </tbody>
        </table>
        <div :class="$style.buttonArea">
          <span :class="[$style.button, $style.black, $style.large]"
            ><input type="submit" accesskey="s" :value="$t('admin.save')"
          /></span>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>
